module.exports = __webpack_public_path__ + "static/img/logo06.da3be3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo06.jpg
// module id = sFRD
// module chunks = 1